export default __webpack_public_path__ + "static/media/r-nobg-logo-fullside-white.a831cf65.png";